var $36d5a33d9da87b96$exports = {};
const $36d5a33d9da87b96$var$canvas = document.querySelector('canvas');
const $36d5a33d9da87b96$var$ctx = $36d5a33d9da87b96$var$canvas.getContext('2d');
const $36d5a33d9da87b96$var$TOP_HUE = 144;
const $36d5a33d9da87b96$var$BOTTOM_HUE = 80;
const $36d5a33d9da87b96$var$getRandomHue = ()=>{
    return Math.floor(Math.random() * ($36d5a33d9da87b96$var$TOP_HUE - $36d5a33d9da87b96$var$BOTTOM_HUE) + $36d5a33d9da87b96$var$BOTTOM_HUE);
};
const $36d5a33d9da87b96$var$getRandomDirection = ()=>{
    return Math.random() > 0.5 ? 1 : -1;
};
const $36d5a33d9da87b96$var$renderPixel = (pixel, context)=>{
    const [x, y, hue] = pixel;
    context.fillStyle = `hsl(${hue}, 54%, 20%)`;
    context.fillRect(x, y, 1, 1);
    context.fillRect(x, y, 1, 1);
};
const $36d5a33d9da87b96$var$renderPixels = (data, context)=>{
    data.forEach((pixel)=>$36d5a33d9da87b96$var$renderPixel(pixel, context));
};
const $36d5a33d9da87b96$var$updatePixel = (pixel)=>{
    let direction = pixel[3];
    const velocity = (Math.random() * 30 + 20) * 0.01 * direction;
    let hue = pixel[2] + velocity;
    if (hue >= $36d5a33d9da87b96$var$BOTTOM_HUE && hue <= $36d5a33d9da87b96$var$TOP_HUE) return [
        pixel[0],
        pixel[1],
        hue,
        direction
    ];
    hue -= 2 * velocity;
    direction *= -1;
    return [
        pixel[0],
        pixel[1],
        hue,
        direction
    ];
};
const $36d5a33d9da87b96$var$updatePixels = (data)=>{
    return data.map($36d5a33d9da87b96$var$updatePixel);
};
const $36d5a33d9da87b96$var$animate = (()=>{
    let pixels = [
        [
            0,
            0,
            $36d5a33d9da87b96$var$getRandomHue(),
            $36d5a33d9da87b96$var$getRandomDirection()
        ],
        [
            1,
            0,
            $36d5a33d9da87b96$var$getRandomHue(),
            $36d5a33d9da87b96$var$getRandomDirection()
        ],
        [
            0,
            1,
            $36d5a33d9da87b96$var$getRandomHue(),
            $36d5a33d9da87b96$var$getRandomDirection()
        ],
        [
            1,
            1,
            $36d5a33d9da87b96$var$getRandomHue(),
            $36d5a33d9da87b96$var$getRandomDirection()
        ]
    ];
    return ()=>{
        pixels = $36d5a33d9da87b96$var$updatePixels(pixels);
        $36d5a33d9da87b96$var$renderPixels(pixels, $36d5a33d9da87b96$var$ctx);
        requestAnimationFrame($36d5a33d9da87b96$var$animate);
    };
})();
$36d5a33d9da87b96$var$animate();


//# sourceMappingURL=site.8bcf01cc.js.map
